import { useLanguage } from "hooks/settings";
import { validateDate } from "../utils/validateDate";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

type Timezone = "UTC" | undefined;

type DateType = "date" | "datetime" | "monthYear";

export const useFormatLocalDate = (
  period: DateType,
  timezone?: Timezone
): ((date: Date) => string) => {
  const language = useLanguage();
  dayjs.locale(language);

  return (date: Date) => {
    const dayjsDate =
      timezone !== undefined ? dayjs(date).tz(timezone) : dayjs(date);

    switch (period) {
      case "date":
        return dayjsDate.format("L");
      case "datetime":
        return dayjsDate.format("L, LTS");
      case "monthYear":
        return dayjsDate.format("MMMM YYYY");
    }
  };
};

export const useFormatLocalDateString = (period: DateType) => {
  const format = useFormatLocalDate(period);
  return (dateString: string) => {
    return format(validateDate(dateString));
  };
};
